import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class ActionHistoryCommand extends CategoryCommand<Record<string, any>> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.ACTION_HISTORY,
    };
  }

  public getIcon(): IconName {
    return 'update-history';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }
}

export default ActionHistoryCommand;
